import React from "react";

// Official provider brand marks (full color), served from /public/brand/providers.
// Colors and proportions are preserved per each provider's brand guidelines.
const PUBLIC = process.env.PUBLIC_URL || "";
const P = `${PUBLIC}/brand/providers`;

function Mark({ src, alt, size, className }) {
  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
      className={className}
      style={{ height: size, width: size, objectFit: "contain" }}
    />
  );
}

export function GoogleCloudMark({ size = 32, className = "" }) {
  return <Mark src={`${P}/googlecloud.svg`} alt="Google Cloud" size={size} className={className} />;
}

export function MicrosoftMark({ size = 32, className = "" }) {
  return <Mark src={`${P}/microsoft.svg`} alt="Microsoft" size={size} className={className} />;
}

export function AlibabaCloudMark({ size = 32, className = "" }) {
  return <Mark src={`${P}/alibabacloud.svg`} alt="Alibaba Cloud" size={size} className={className} />;
}

// Hybrid / Edge is a Cloud Beaker concept (no third-party brand) — kept as an on-brand SVG.
export function HybridEdgeMark({ size = 32, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" className={className} xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Hybrid and Edge">
      <path d="M34 22.5a7.5 7.5 0 0 0-14.2-2.3A6 6 0 0 0 12 26a6 6 0 0 0 6 6h15a6.5 6.5 0 0 0 1-12.94" fill="#eaf1fd" stroke="#1667e0" strokeWidth="2" strokeLinejoin="round" />
      <circle cx="18" cy="38" r="2" fill="#1e9e57" />
      <circle cx="30" cy="38" r="2" fill="#1e9e57" />
      <path d="M18 32v6M30 32v6" stroke="#1e9e57" strokeWidth="1.6" />
    </svg>
  );
}
